<div class="scroll-active attachment-container">
  @for (record of records; track record; let i = $index) {
    <div [attr.data-id]="'ttachment-board-'+i" [attr.data-order]="i"
      class="attachment-board " style="width: 250px; margin-left: 15px; margin-right: 15px;">
      <header class="attachment-board-header">
        <div [attr.data-text]="record.fullname" class="attachment-title-board truncate">
        {{record.fullname}}</div>
        <div class="dropdown">
          <div ngbDropdown [open]="false" [autoClose]="true" class="d-inline-block">
            <i data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="dropdownBasic1"
              dropdown-menu dropdown-menu-left show ngbDropdownToggle (click)="$event.stopPropagation();"
            class="dropdown-toggle fas fa-ellipsis-v "></i>
            <div class="dropdown-menu" ngbDropdownMenu="dropdownBasic1">
              @if (record.fullname.indexOf('.docx') !== -1 || record.fullname.indexOf('.xlsx') !== -1) {
                <div
                  >
                  <!-- <a class="dropdown-item icon-table disabled" target="_blank"  href="">
                  <i class="far fa-eye"></i>
                  Ver
                </a> -->
              </div>
            } @else {
              <a class="dropdown-item icon-table" target="_blank" href="{{record.urlView}}">
                <i class="far fa-eye"></i>
                Ver
              </a>
            }
            <a class="dropdown-item icon-table" target="_blank" href="{{record.url}}">
              <i class="fas fa-download"></i>
              Descargar
            </a>
            <a class="dropdown-item icon-table" target="_blank" (click)="deleteItem(record.id,record.requirementid,record.storageid,record.templateid)">
              <i class="far fa-trash-alt"></i>
              Eliminar
            </a>
          </div>
        </div>
      </div>
    </header>
    <div class="notes-footer d-flex justify-content-between align-items-end mt-1">
      <div class="notes-footer-left d-flex align-items-center">
        <div class="notes-due-date mr-5 ml-3">
          <i class="far fa-clock font-size-small mr-1"></i>
          <span class="font-size-small">{{ record.date | date:'MMM d, y h:mm a':'':'en-US' }}</span>
        </div>
      </div>
      <div class="notes-footer-right">
        <div class="notes-users mr-3">
          <ul class="list-unstyled users-list cursor-pointer m-0 d-flex align-items-center">
            <li class="avatar pull-up my-0 " triggers="click" placement="left" [ngbTooltip]="record.name">
              <app-avatar-photo [photoUrl]="undefined" [name]="record.name"></app-avatar-photo>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
}
</div>
